// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t77_","left":"styles_left__37u8Q","navigationLink":"styles_navigationLink__2crVJ"};